'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fireAnalyticsScreenEvent = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _pickBy = require('lodash/pickBy');

var _pickBy2 = _interopRequireDefault(_pickBy);

var _events = require('./events');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNotUndefined = function isNotUndefined(a) {
    return !(0, _isUndefined2.default)(a);
};

var mapPayload = function mapPayload(payload) {
    return (0, _pickBy2.default)((0, _extends3.default)({}, payload, payload.attributes, {
        attributes: undefined
    }), isNotUndefined);
};

var fireAnalyticsScreenEvent = exports.fireAnalyticsScreenEvent = function fireAnalyticsScreenEvent(event, payload) {
    var clonedEvent = event.clone();
    clonedEvent.update((0, _extends3.default)({}, mapPayload(payload || {}), { analyticsType: _events.SCREEN_EVENT_TYPE })).fire();
};